import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Phone, Menu, X } from 'lucide-react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="absolute top-0 left-0 right-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-24">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <span className="text-2xl font-bold text-white drop-shadow-lg">Kalamata Airport</span>
            <span className="text-2xl font-bold ml-2 text-[#36827f] drop-shadow-lg">Taxi</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <Link to="/" className="text-white/90 hover:text-white transition font-medium drop-shadow">
              Home
            </Link>
            <Link to="/routes" className="text-white/90 hover:text-white transition font-medium drop-shadow">
              Routes
            </Link>
            <Link to="/contact" className="text-white/90 hover:text-white transition font-medium drop-shadow">
              Contact
            </Link>
          </nav>

          {/* Phone Button - Desktop */}
          <a 
            href="tel:+306932421170" 
            className="hidden md:flex items-center gap-2 px-5 py-2.5 rounded-full bg-white/10 backdrop-blur-md text-white border border-white/20 hover:bg-white/20 transition font-medium"
          >
            <Phone className="w-4 h-4" />
            <span>+30 693 242 1170</span>
          </a>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-white"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <Menu className="h-6 w-6" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-[#2d232e]/95 backdrop-blur-lg rounded-2xl mt-2 p-6 border border-white/10">
            <nav className="flex flex-col space-y-4">
              <Link 
                to="/" 
                className="text-white/90 hover:text-white transition font-medium py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                Home
              </Link>
              <Link 
                to="/routes" 
                className="text-white/90 hover:text-white transition font-medium py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                Routes
              </Link>
              <Link 
                to="/contact" 
                className="text-white/90 hover:text-white transition font-medium py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                Contact
              </Link>
              
              {/* Phone Button - Mobile */}
              <a 
                href="tel:+306932421170" 
                className="flex items-center justify-center gap-2 px-5 py-3 rounded-xl bg-[#36827f] text-white font-medium mt-4"
                onClick={() => setMobileMenuOpen(false)}
              >
                <Phone className="w-4 h-4" />
                <span>+30 693 242 1170</span>
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
